module.exports = __webpack_public_path__ + "img/tartrais.783c4e84.jpg";